import useSwr from 'swr';
import Axios from '@/utils/Axios';
import getDomainPlatform, {
  DomainPlatformValue,
} from '@/utils/getDomainPlatform';
import { getSubject } from '@/utils/subject';

interface RequestQuery {
  platform?: DomainPlatformValue;
  /**
   * 用户当前学科
   */
  subject?: number;
}

export interface Profile {
  /**
   * 地区代码
   */
  areaCode?: string;
  /**
   * 头像
   */
  avatar?: string;
  /**
   * 是否启用
   */
  enabled: number;
  /**
   * 性别 1男 2女
   */
  gender?: number;
  /**
   * 用户id
   */
  id: number;
  /**
   * 身份 'staff' | 'student' | 'teacher' | 'parent'
   */
  identity: Identity;
  /**
   * 姓名
   */
  name: string;
  /**
   * 手机号
   */
  phone?: string;
  /**
   * 偏好是否已设置
   */
  prefer: boolean;
  /**
   * 系统角色
   */
  sysRole: string;
  /**
   * 用户设置课
   */
  section?: number;
  /**
   * 用户设置单元
   */
  unit?: number;
  /**
   * 教师工号
   */
  teacherCode?: string;
}

export enum Identity {
  Parent = 'parent',
  Staff = 'staff',
  Student = 'student',
  Teacher = 'teacher',
}

export async function getProfile() {
  const platform = getDomainPlatform();

  const response = await Axios.get<Profile>(`/users/profile`, {
    params: {
      platform,
      subject: Number(getSubject().id),
    } satisfies RequestQuery,
  });
  return response.data;
}

export default function useProfile() {
  const platform = getDomainPlatform();

  const { data, mutate } = useSwr(['/users/profile', { platform }], () =>
    getProfile(),
  );

  return {
    data,
    mutate,
  } as const;
}
